<ng-container *ngIf="tooltipTemplate; else stringTooltip">
  <div
    [ngClass]="{
      'white-tooltip': isWhite,
      'custom-info-icon': !isWhite && isDefaultPaymentMethodAdded,
      'custom-redinfo-icon': !isDefaultPaymentMethodAdded
    }"
    [tooltipStyleClass]="addClass"
    appendTo="body"
    tooltipPosition="top"
    tooltipEvent="manual"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
    (click)="onClick($event)"
    [pTooltip]="customTooltipTemplate" 
  >
  </div>

  <!-- This ng-template is rendered as tooltip content -->
  <ng-template #customTooltipTemplate>
    <ng-container *ngTemplateOutlet="tooltipTemplate; context: tooltipContext"></ng-container>
  </ng-template>
</ng-container>


<ng-template #stringTooltip>
  <!-- String tooltip -->
  <div
    [ngClass]="{
      'white-tooltip': isWhite,
      'custom-info-icon': !isWhite && isDefaultPaymentMethodAdded,
      'custom-redinfo-icon': !isDefaultPaymentMethodAdded
    }"
    [tooltipStyleClass]="addClass"
    [pTooltip]="tooltipMessageString"
    [tooltipPosition]="tooltipPosition"
    appendTo="body"
    tooltipEvent="manual"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
    (click)="onClick($event)"
  ></div>
</ng-template>
